document.addEventListener('DOMContentLoaded', function() {
  // Initialize How We Help tabs
  initHowWeHelpTabs();
  // Add lash icons to bullet points
  addLashIcons();
});

// Also initialize if DOM is already loaded (for dynamic content)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initHowWeHelpTabs();
    addLashIcons();
  });
} else {
  initHowWeHelpTabs();
  addLashIcons();
}

function initHowWeHelpTabs() {
  // Find all How We Help sections on the page
  const sections = document.querySelectorAll('.how-we-help');
  
  sections.forEach((section, sectionIndex) => {
    const tabButtons = section.querySelectorAll('.how-we-help__tab-button');
    const tabContents = section.querySelectorAll('.how-we-help__tab-content');
    
    tabButtons.forEach((button, buttonIndex) => {
      // Remove any existing event listeners
      button.removeEventListener('click', handleTabClick);
      // Add new event listener
      button.addEventListener('click', handleTabClick);
    });
    
    function handleTabClick(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const targetTabId = e.target.getAttribute('data-tab');
      
      // Remove active class from all buttons and contents
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
      });
      
      tabContents.forEach(content => {
        content.classList.remove('active');
      });
      
      // Add active class to clicked button
      e.target.classList.add('active');
      
      // Show corresponding content
      const targetContent = section.querySelector(`[data-tab="${targetTabId}"].how-we-help__tab-content`);
      if (targetContent) {
        targetContent.classList.add('active');
        // Re-add icons after tab switch
        setTimeout(addLashIcons, 100);
      }
    }
  });
}

function addLashIcons() {
  // Lash icon SVG
  const lashIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#CB929A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="width: 22px; height: 22px; display: block;"><path d="M3 8c2-3 5-4 8-2s4 4 2 7M8 10c1-2 3-2 5-1s2 2 1 4M13 12c1-1 2-1 3 0s1 2 0 3"/></svg>';
  
  // Find all list items in content text
  const contentListItems = document.querySelectorAll('.how-we-help__content-text ul li, .how-we-help__content-text.rte ul li');
  
  contentListItems.forEach((li) => {
    // Check if icon already exists
    if (li.querySelector('.lash-icon')) {
      return;
    }
    
    // Create icon wrapper
    const iconWrapper = document.createElement('span');
    iconWrapper.className = 'lash-icon';
    iconWrapper.style.cssText = 'position: absolute; left: 0; top: 0.1em; width: 22px; height: 22px; display: block; z-index: 1;';
    iconWrapper.innerHTML = lashIconSVG;
    
    // Ensure parent has relative positioning
    if (getComputedStyle(li).position === 'static') {
      li.style.position = 'relative';
    }
    if (!li.style.paddingLeft || parseInt(li.style.paddingLeft) < 32) {
      li.style.paddingLeft = '2rem';
    }
    
    // Insert icon
    li.insertBefore(iconWrapper, li.firstChild);
  });
  
  // Also add to bullet items
  const bulletItems = document.querySelectorAll('.how-we-help__bullet-item');
  
  bulletItems.forEach((li) => {
    // Check if icon already exists
    if (li.querySelector('.lash-icon')) {
      return;
    }
    
    // Create icon wrapper
    const iconWrapper = document.createElement('span');
    iconWrapper.className = 'lash-icon';
    iconWrapper.style.cssText = 'position: absolute; left: 0; top: 0.1em; width: 22px; height: 22px; display: block; z-index: 1;';
    iconWrapper.innerHTML = lashIconSVG;
    
    // Ensure parent has relative positioning
    if (getComputedStyle(li).position === 'static') {
      li.style.position = 'relative';
    }
    if (!li.style.paddingLeft || parseInt(li.style.paddingLeft) < 32) {
      li.style.paddingLeft = '2rem';
    }
    
    // Insert icon
    li.insertBefore(iconWrapper, li.firstChild);
  });
}
